var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_request-form" },
    [
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center px-2 p-lg-5 mt-2",
              attrs: { lg: "12" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "12", md: "8", lg: "8" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [_vm._v(" Olá, bem-vindo(a)! ")]
                      ),
                      !_vm.headerDescription
                        ? _c("b-card-text", { staticClass: "mb-2" }, [
                            _vm._v(
                              " Este formulário foi construído para você solicitar tratamento do(s) incidente(s) relacionados aos dados pessoais."
                            ),
                            _c("br"),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm.headerDescription
                        ? _c("b-card-text", {
                            directives: [
                              {
                                name: "html-safe",
                                rawName: "v-html-safe",
                                value: _vm.headerDescription,
                                expression: "headerDescription"
                              }
                            ],
                            staticClass: "mb-2"
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "mb-3 p-2 border rounded",
                          staticStyle: {
                            "background-color": "#f8f9fa",
                            "border-color": "#dee2e6"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-start" },
                            [
                              _c("feather-icon", {
                                staticClass: "text-info mr-2",
                                attrs: { icon: "InfoIcon", size: "16" }
                              }),
                              _c(
                                "div",
                                { staticClass: "flex-grow-1" },
                                [
                                  _c("p", { staticClass: "mb-1 text-dark" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "Já preencheu este formulário anteriormente?"
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "p",
                                    { staticClass: "mb-1 text-muted small" },
                                    [
                                      _vm._v(
                                        " Se você já cadastrou um formulário de incidente e deseja consultar, editar ou acompanhar a situação, utilize a opção de busca. "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-link",
                                    {
                                      staticClass:
                                        "text-primary font-weight-semibold small",
                                      on: { click: _vm.showPopupFindForm }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          icon: "SearchIcon",
                                          size: "12"
                                        }
                                      }),
                                      _vm._v(
                                        " Clique aqui para consultar seu formulário "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("hr", { staticClass: "mb-4" }),
                      _c(
                        "validation-observer",
                        { ref: "requestForm" },
                        [
                          _c(
                            "b-form",
                            {
                              staticClass: "mb-1 mt-2",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send($event)
                                }
                              }
                            },
                            [
                              _vm.dataForm && _vm.dataForm.id
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("incident_form_protocol"),
                                        "label-for": "incident_form_protocol"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "incident_form_protocol",
                                          name: "incident_form_protocol",
                                          disabled: true,
                                          type: "text",
                                          readonly: ""
                                        },
                                        model: {
                                          value: _vm.dataForm.protocol_number,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataForm,
                                              "protocol_number",
                                              $$v
                                            )
                                          },
                                          expression: "dataForm.protocol_number"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.dataForm && _vm.dataForm.id
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("incident_form_status"),
                                        "label-for": "incident_form_status"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "incident_form_status",
                                          name: "incident_form_status",
                                          disabled: true,
                                          type: "text",
                                          readonly: ""
                                        },
                                        model: {
                                          value: _vm.dataForm.status_str,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataForm,
                                              "status_str",
                                              $$v
                                            )
                                          },
                                          expression: "dataForm.status_str"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.dataForm && _vm.dataForm.id
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("type_form"),
                                        "label-for": "type_form"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "type_form",
                                          name: "type_form",
                                          disabled: true,
                                          type: "text",
                                          readonly: ""
                                        },
                                        model: {
                                          value: _vm.dataForm.type_form_str,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataForm,
                                              "type_form_str",
                                              $$v
                                            )
                                          },
                                          expression: "dataForm.type_form_str"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("type_form"),
                                        "label-for": "type_form"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("type_form"),
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-radio-group", {
                                                  attrs: {
                                                    options: _vm.typeFormList,
                                                    "value-field": "key",
                                                    "text-field": "label",
                                                    name: "typeForm",
                                                    stacked: "",
                                                    disabled:
                                                      _vm.enableUpdateForm
                                                  },
                                                  on: {
                                                    change: _vm.changeTypeForm
                                                  },
                                                  model: {
                                                    value: _vm.typeForm,
                                                    callback: function($$v) {
                                                      _vm.typeForm = $$v
                                                    },
                                                    expression: "typeForm"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      })
                                    ],
                                    1
                                  ),
                              _vm.typeForm === "CA"
                                ? _c("RequestFormIncidentCoupAttempt", {
                                    ref: "coupAttempt",
                                    attrs: {
                                      param_encrypt: _vm.param_encrypt,
                                      typeForm: _vm.typeForm,
                                      dataForm: _vm.dataForm,
                                      disabledFields: _vm.disabledFields
                                    }
                                  })
                                : _vm._e(),
                              _vm.typeForm === "GE"
                                ? _c("RequestFormIncidentGeneral", {
                                    ref: "general",
                                    attrs: {
                                      param_encrypt: _vm.param_encrypt,
                                      typeForm: _vm.typeForm,
                                      dataForm: _vm.dataForm,
                                      disabledFields: _vm.disabledFields
                                    }
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "incident_form_attachments"
                                          ),
                                          "label-for":
                                            "incident_form_attachments"
                                        }
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "incident_form_attachments"
                                            )
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-file", {
                                                    attrs: {
                                                      id: "attachments",
                                                      placeholder:
                                                        "Clique para selecionar os arquivos ou arraste aqui...",
                                                      "drop-placeholder":
                                                        "Solte os arquivos aqui...",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      name:
                                                        "generalAttachments",
                                                      disabled:
                                                        _vm.disabledFields,
                                                      multiple: "",
                                                      accept:
                                                        ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.generalAttachments,
                                                      callback: function($$v) {
                                                        _vm.generalAttachments = $$v
                                                      },
                                                      expression:
                                                        "generalAttachments"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "form-text text-muted"
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "feather icon-upload mr-1"
                                                      }),
                                                      _vm._v(
                                                        " Selecione um ou mais arquivos para anexar. Todos os anexos são opcionais. "
                                                      )
                                                    ]
                                                  ),
                                                  _vm.generalAttachments &&
                                                  _vm.generalAttachments.length
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "mt-2" },
                                                        [
                                                          _c(
                                                            "b-list-group",
                                                            _vm._l(
                                                              _vm.generalAttachments,
                                                              function(
                                                                file,
                                                                idx
                                                              ) {
                                                                return _c(
                                                                  "b-list-group-item",
                                                                  {
                                                                    key: idx,
                                                                    staticClass:
                                                                      "d-flex justify-content-between align-items-center"
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "feather icon-file-text text-primary mr-2"
                                                                      }),
                                                                      _vm.getDownloadUrl(
                                                                        file
                                                                      )
                                                                        ? _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2 download-link text-primary",
                                                                              attrs: {
                                                                                href: _vm.getDownloadUrl(
                                                                                  file
                                                                                ),
                                                                                target:
                                                                                  "_blank",
                                                                                title:
                                                                                  "Baixar arquivo"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "feather icon-download"
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.getFileName(
                                                                                file
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm.getFileSize(
                                                                        file
                                                                      )
                                                                        ? _c(
                                                                            "small",
                                                                            {
                                                                              staticClass:
                                                                                "ml-2 text-muted"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " (" +
                                                                                  _vm._s(
                                                                                    _vm.formatFileSize(
                                                                                      _vm.getFileSize(
                                                                                        file
                                                                                      )
                                                                                    )
                                                                                  ) +
                                                                                  ") "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]),
                                                                    _vm.enableUpdateForm
                                                                      ? _c(
                                                                          "b-button",
                                                                          {
                                                                            attrs: {
                                                                              variant:
                                                                                "outline-danger",
                                                                              size:
                                                                                "sm"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeAttachment(
                                                                                  idx
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "feather icon-trash-2"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ])
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vx-col w-full d-flex justify-content-end"
                                  },
                                  [
                                    _vm.enableSubmit
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "waves-effect float-right mr-2",
                                            attrs: {
                                              type: "submit",
                                              variant: "primary"
                                            }
                                          },
                                          [_vm._v(" Enviar ")]
                                        )
                                      : _vm._e(),
                                    _vm.enableUpdateForm
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "waves-effect float-right mr-2",
                                            attrs: {
                                              type: "submit",
                                              variant: "primary"
                                            }
                                          },
                                          [_vm._v(" Salvar ")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "waves-effect float-right",
                                        attrs: {
                                          type: "button",
                                          variant: "secondary"
                                        },
                                        on: { click: _vm.clearFields }
                                      },
                                      [_vm._v(" Limpar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-card-footer",
                        { staticClass: "text-right" },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Desenvolvido por:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://securamdata.com",
                                target: "_brank"
                              }
                            },
                            [_vm._v("securamdata.com")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            width: "550px",
            title: "Procotolo",
            "ok-only": "",
            centered: ""
          },
          model: {
            value: _vm.activeDialogAge,
            callback: function($$v) {
              _vm.activeDialogAge = $$v
            },
            expression: "activeDialogAge"
          }
        },
        [
          _c("div", { staticClass: "con-content" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.protocolNumber) + " ")]),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.msgDescription) } })
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            width: "550px",
            title: "Corrigir formulário preenchido",
            "hide-footer": "",
            centered: ""
          },
          model: {
            value: _vm.activeDialogFindForm,
            callback: function($$v) {
              _vm.activeDialogFindForm = $$v
            },
            expression: "activeDialogFindForm"
          }
        },
        [
          _c(
            "div",
            { staticClass: "con-content" },
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "E-mail do cadastro:",
                        "label-for": "search-email"
                      }
                    },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c(
                            "b-input-group-prepend",
                            [
                              _c(
                                "b-input-group-text",
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "MailIcon", size: "16" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("b-form-input", {
                            attrs: {
                              id: "search-email",
                              type: "email",
                              placeholder:
                                "Digite o e-mail usado no cadastro do formulário",
                              required: ""
                            },
                            model: {
                              value: _vm.searchFormData.email,
                              callback: function($$v) {
                                _vm.$set(_vm.searchFormData, "email", $$v)
                              },
                              expression: "searchFormData.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Protocolo:",
                        "label-for": "search-protocol"
                      }
                    },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c(
                            "b-input-group-prepend",
                            [
                              _c(
                                "b-input-group-text",
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "FileTextIcon", size: "16" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("b-form-input", {
                            attrs: {
                              id: "search-protocol",
                              placeholder: "Digite o número do protocolo",
                              required: ""
                            },
                            model: {
                              value: _vm.searchFormData.protocol,
                              callback: function($$v) {
                                _vm.$set(_vm.searchFormData, "protocol", $$v)
                              },
                              expression: "searchFormData.protocol"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3 d-flex justify-content-end"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled:
                              !_vm.searchFormData.email ||
                              !_vm.searchFormData.protocol
                          },
                          on: { click: _vm.searchFormDataMethod }
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "SearchIcon" }
                          }),
                          _vm._v(" Consultar ")
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function($event) {
                              _vm.activeDialogFindForm = false
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "align-middle" }, [
                            _vm._v("Cancelar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }